import { Link } from 'react-router-dom';
import { Button } from '../components/ui/button';
import { ArrowRight, QrCode } from 'lucide-react';
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogTitle,
  DialogTrigger,
} from '../components/ui/dialog';

export const Hero = () => {
  return (
    <section 
      data-testid="hero-section" 
      className="relative min-h-screen bg-navy grain-overlay overflow-hidden"
    >
      {/* Background Image with Overlay */}
      <div className="absolute inset-0">
        <img
          src="https://images.unsplash.com/photo-1737823934403-c43c450f25de?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2Njl8MHwxfHNlYXJjaHwzfHxsdXh1cnklMjBtb2Rlcm4lMjBob21lJTIwZXh0ZXJpb3IlMjB0d2lsaWdodHxlbnwwfHx8fDE3NzM0MzUyNTB8MA&ixlib=rb-4.1.0&q=85"
          alt="Modern home exterior"
          className="w-full h-full object-cover opacity-30"
        />
        <div className="absolute inset-0 bg-gradient-to-r from-navy via-navy/95 to-navy/70" />
      </div>

      <div className="relative z-10 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 pt-32 pb-20">
        <div className="grid lg:grid-cols-2 gap-12 items-center min-h-[calc(100vh-160px)]">
          {/* Left Content */}
          <div className="space-y-8">
            {/* Badge */}
            <div 
              className="inline-flex items-center space-x-2 bg-white/10 backdrop-blur-sm px-4 py-2 border border-tan/30"
              data-testid="hero-badge"
            >
              <span className="w-2 h-2 bg-copper rounded-full animate-pulse" />
              <span className="text-tan text-xs font-inter uppercase tracking-widest">
                Available for projects
              </span>
            </div>

            {/* Main Headline */}
            <h1 
              className="text-4xl sm:text-5xl lg:text-6xl xl:text-7xl font-playfair font-bold text-white leading-[1.1] tracking-tight"
              data-testid="hero-headline"
            >
              Built Right.<br />
              Finished on Time.<br />
              <span className="text-copper">Backed by 30 Years.</span>
            </h1>

            {/* Subheadline */}
            <p 
              className="text-lg text-white/70 font-inter leading-relaxed max-w-xl"
              data-testid="hero-subheadline"
            >
              DFW Metroplex's full-service contractor for roofing, flooring, plumbing, electrical, painting, carpentry, sheetrock, AC, and full home renovations. One call. Every trade.
            </p>

            {/* CTAs */}
            <div className="flex flex-col sm:flex-row gap-4 pt-4">
              <Link to="/contact">
                <Button 
                  data-testid="hero-cta-primary"
                  className="bg-copper hover:bg-copper/90 text-white px-8 py-6 text-xs font-bold uppercase tracking-widest group"
                >
                  Book My Estimate Now
                  <ArrowRight className="ml-2 h-4 w-4 group-hover:translate-x-1 transition-transform" />
                </Button>
              </Link>
              <Dialog>
                <DialogTrigger asChild>
                  <Button 
                    data-testid="hero-cta-payment"
                    variant="outline"
                    className="border-2 border-white/30 text-white hover:bg-white hover:text-navy px-8 py-6 text-xs font-bold uppercase tracking-widest"
                  >
                    <QrCode className="mr-2 h-4 w-4" />
                    Make a Payment
                  </Button>
                </DialogTrigger>
                <DialogContent className="sm:max-w-md bg-white">
                  <DialogHeader>
                    <DialogTitle className="font-playfair text-navy text-2xl">Pay with Zelle</DialogTitle>
                    <DialogDescription className="text-navy/60">
                      Scan the QR code below with your banking app to send payment
                    </DialogDescription>
                  </DialogHeader>
                  <div className="flex flex-col items-center py-6">
                    <div className="bg-white p-4 rounded-lg shadow-lg">
                      <img 
                        src="https://customer-assets.emergentagent.com/job_construct-hub-276/artifacts/0bmfs3a5_Zell.jpeg" 
                        alt="Zelle QR Code"
                        className="w-48 h-48 object-cover object-center"
                        style={{ objectPosition: '50% 35%' }}
                      />
                    </div>
                    <p className="mt-4 text-navy font-inter text-sm text-center font-medium">
                      C.A.B ENTERPRISES OF TEXAS
                    </p>
                  </div>
                </DialogContent>
              </Dialog>
            </div>

          </div>
        </div>
      </div>

      {/* Bottom Gradient */}
      <div className="absolute bottom-0 left-0 right-0 h-32 bg-gradient-to-t from-off-white to-transparent" />
    </section>
  );
};

export default Hero;
